import GroupIcon from '@mui/icons-material/GroupWork'
import GroupMemberList from './GroupMemberList'

export default {
  list: GroupMemberList,
  icon: GroupIcon,
  recordRepresentation: 'email',
}
